/**
 * The hash as the router reads it: path segments, and the query after `?`.
 * `#/verify?token=sbv_…` is `{parts: ['verify'], params: token=…}`. The
 * token lives in the hash, so it never reaches a server or a Referer.
 */

export interface Route {
  readonly parts: string[];
  readonly params: URLSearchParams;
}

export const readRoute = (hash: string): Route => {
  const [path = '', search = ''] = hash.replace(/^#\/?/, '').split('?', 2);
  return {
    parts: path.split('/').map(decodeURIComponent).filter(Boolean),
    params: new URLSearchParams(search),
  };
};

/** Screens a visitor without a key may open. */
export const OPEN_SCREENS: readonly string[] = ['connect', 'signup', 'verify'];
